export default () => {

    const doms = document.querySelectorAll('[data-faqs]');

    const runFilter = (dom, categories) => {
        let items = dom.querySelectorAll('[data-faq-item]');
        if (categories.length) {
            for (const item of items) {
                const cats = JSON.parse(item.getAttribute('data-categories'));
                const isIn = categories.filter(c => cats.indexOf(c) >= 0);

                if (isIn.length) {
                    item.classList.remove('hidden-faq');
                } else {
                    item.classList.add('hidden-faq');
                }

            }
        } else {
            for (const item of items) {
                item.classList.remove('hidden-faq');
            }
        }
    }

    const initFAQs = (dom) => {
        let active = [];
        let buttons = dom.querySelectorAll('[data-filter]');
        let allButton = dom.querySelector('[data-filter="0"]');

        for (const button of buttons) {
            button.addEventListener('click', (e) => {
                e.preventDefault();
                let category = button.getAttribute('data-filter');
                if (!isNaN(category)) {
                    category = parseInt(category)
                }
                if (category === 0) {
                    active = [];
                    for (const otherButtons of buttons) {
                        otherButtons.classList.remove('active');
                    }
                    button.classList.add('active');
                } else {
                    allButton.classList.remove('active');
                    if (active.indexOf(category) >= 0) {
                        button.classList.remove('active');
                        active.splice(active.indexOf(category), 1);
                    } else {
                        active.push(category);
                        button.classList.add('active');
                    }
                }
                runFilter(dom, active);
            });
        }

    }


    if (doms.length) {
        for (const dom of doms) {
            initFAQs(dom);
        }
    }

}
